import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { getAllBookings } from '../../shared/api/user';
import { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import Box from '@mui/material/Box';
import tone from '../../audio/notify.mp3';
import toast, { Toaster } from 'react-hot-toast';

export default function BasicTable() {
    const [bookings, setBookings] = useState([]);
    const [Offset, setOffset] = useState(0);
    const previousOrdersRef = useRef([]);
    const [isNewOrderAdded, setIsNewOrderAdded] = useState(false);
    const [notificationSent, setNotificationSent] = useState(false);

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        let rows = await getAllBookings();
        setBookings(rows.data.booking);
        console.log(rows)

        const newOrders = rows.data.booking.filter(order => !previousOrdersRef.current.some(prevOrder => prevOrder._id === order._id));

        if (newOrders.length > 0) {
            const latestOrderTimestamp = moment(newOrders[0].createdAt).valueOf();
            const lastNotificationTimestamp = localStorage.getItem('lastNotificationTimestampBooking');
            if (lastNotificationTimestamp === null || latestOrderTimestamp > Number(lastNotificationTimestamp)) {
                setIsNewOrderAdded(true);
                setNotificationSent(false);
                localStorage.setItem('lastNotificationTimestampBooking', latestOrderTimestamp);
            }
        }
        previousOrdersRef.current = rows.data.booking;

        const saved = sessionStorage.getItem(`${location.pathname}-scrollPos2`);
        if (saved) {
            const { scrollPosition, timestamp } = JSON.parse(saved);

            // Clear the scroll position if it's older than 6 hours (21600000 milliseconds)
            if (Date.now() - timestamp > 21600000) {
                sessionStorage.removeItem(`${location.pathname}-scrollPos2`);
            } else {
                window.scrollTo(0, scrollPosition);
            }
        }
    }

    useEffect(() => {
        init();
        const interval = setInterval(() => {
            init();
        }, 25000);
        const previousOrders = JSON.parse(localStorage.getItem('previousOrders'));
        previousOrdersRef.current = previousOrders || [];
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (isNewOrderAdded && !notificationSent) {
            showNotification();
            setNotificationSent(true);
        }
    }, [isNewOrderAdded, notificationSent]);

    const showNotification = async () => {
        let audio = new Audio(tone);
        setTimeout(() => {
            audio.play();
            notify();
        }, 1000)
    }
    const notify = () => toast('A new booking has been received.');


    async function paginationClickedNext() {
        setOffset(Offset + 15);
        init();
    }

    async function paginationClickedPrev() {
        if (Offset > 0) {
            setOffset(Offset - 15);
            init();
        }
    }

    return (
        <>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Customer Name</TableCell>
                            <TableCell align="left">Phone Number</TableCell>
                            <TableCell align="right">Email</TableCell>
                            <TableCell align="right">Total Boxes</TableCell>
                            <TableCell align="right">Location</TableCell>
                            <TableCell align="right">Order Time</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {bookings?.map((row) => (
                            <TableRow
                                key={row._id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell align="left" style={{ cursor: 'pointer' }}>{row?.name}</TableCell>
                                <TableCell align="left" style={{ cursor: 'pointer' }}>{row?.phoneNumber}</TableCell>
                                <TableCell align="right" style={{ cursor: 'pointer' }}>{row?.email}</TableCell>
                                <TableCell align="right" style={{ cursor: 'pointer' }}>{row?.totalBoxes}</TableCell>
                                <TableCell align="right" style={{ cursor: 'pointer' }}>{row?.distributionArea}</TableCell>
                                <TableCell align="right" style={{ cursor: 'pointer' }}>{moment(row.createdAt).format('MMM Do YY, h:mm a')}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <Box textAlign='center'>
                    <Button onClick={() => paginationClickedNext()} variant="text">Load next</Button>
                    {Offset > 0 && <Button onClick={() => paginationClickedPrev()} variant="text">Load previous</Button>}
                </Box>
            </TableContainer>
        </>

    );
}